import React, { useEffect, useState } from "react";
import "./styles.scss";
import { FormHeader, CategoryCard } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewLiveFeed } from "../CreateNewItem";
import { getLanguage } from "../../utils/environment";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { setLiveFeedList, setSelectFeed } from "./redux/actions";
import { deleteLiveFeed, getAllLiveFeed } from "./service/liveFeed.service";
import { Store } from "react-notifications-component";

const lan = getLanguage();

const LiveFeed = () => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectLiveFeed, setSelectLiveFeed] = useState("");
  const dispatch = useDispatch();

  const liveFeedList = useSelector(
    (state) => state.liveFeedReducer.liveFeedList
  );

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const getList = await getAllLiveFeed();
      console.log("Get All Live Feed : ", getList);

      if (getList?.data) {
        dispatch(setLiveFeedList(getList.data));
      } else {
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error fetching Data", error);
    }
  };

  const onClickRefresh = async () => {
    setIsLoading(true);
    await fetchData();
    setIsLoading(false);
  };

  return (
    <>
      <div className="hne-live-feed-wrapper">
        <div className="col-9 live-feed-body-wrapper">
          <FormHeader
            data={{
              formHeader: "Live Feed",
              size: "md-md",
            }}
          />
          <div className="hne-sub-header-wrapper">
            <div className="shw-id">Id</div>
            <div className="shw-si"> </div>
            <div className="shw-si">News</div>
          </div>
          <div className="hne-body-wrapper">
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 300 }}
            >
              {Array.isArray(liveFeedList) && liveFeedList.length > 0 ? (
                liveFeedList.map((feed) => (
                  <CategoryCard
                    isSelect={selectLiveFeed === feed?.news_id}
                    id={feed?.news_id}
                    nameEN={feed?.title?.en || feed?.title?.si}
                    edit="Edit"
                    onClick={() => {
                      setSelectLiveFeed(feed?.news_id);
                      dispatch(setSelectFeed(feed));
                    }}
                    delete="Delete"
                    onClickRemove={async (e) => {
                      setIsLoading(true);
                      try {
                        let result = await deleteLiveFeed(feed?.news_id);
                        console.log("Delete Live Feed Result: ", result);
                        if (result?.data) {
                          Store.addNotification({
                            title: "Success",
                            message: "Live Feed successfully deleted",
                            type: "success",
                            container: "top-right",
                            dismiss: {
                              duration: 2000,
                              onScreen: true,
                            },
                          });
                        }
                        await onClickRefresh();
                      } catch (error) {
                        console.log("Error deleting Live Feed", error);
                        Store.addNotification({
                          title: "Error",
                          message: "Failed to delete Live Feed",
                          type: "danger",
                          container: "top-right",
                          dismiss: {
                            duration: 2000,
                            onScreen: true,
                          },
                        });
                      }
                    }}
                  />
                ))
              ) : (
                <div className="error-message">No Live Feed Found</div>
              )}
            </Scrollbars>
          </div>
        </div>

        {/*right side*/}
        <div className="col-3 live-feed-right-side-wrapper">
          <CreateNewLiveFeed refresh={onClickRefresh} />
        </div>
      </div>
    </>
  );
};
export default withRouter(LiveFeed);
